import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import CssCodeEditor from "../../../components/CssCodeEditor";
import JsCodeEditor from "../../../components/JsCodeEditor";
import ColorPicker from "../../../components/ColorPicker";

const AppearanceTab = ({ handleLayoutChange, selectedLayout,updateAgeVerificationTabData,ageVerificationTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [overlayBackgroundColor, setOverlayBackgroundColor] = useState(ageVerificationTabData.overlay_background_color);
    const [popupBackgroundColor, setPopupBackgroundColor] = useState(ageVerificationTabData.popup_background_color);
    const [textColor, setTextColor] = useState(ageVerificationTabData.text_color);
    const [submitButtonColor, setSubmitButtonColor] = useState(ageVerificationTabData.submit_button_color);
    const [yesButtonColor, setYesButtonColor] = useState(ageVerificationTabData.yes_button_color);
    const [noButtonColor, setNoButtonColor] = useState(ageVerificationTabData.no_button_color);
    const [messageFont, setMessageFont] = useState(ageVerificationTabData.message_font);
    const [messageFontDropdownOpen, setMessageFontDropdownOpen] = useState(false);
    const [textFont, setTextFont] = useState(ageVerificationTabData.text_font);
    const [textFontDropdownOpen, setTextFontDropdownOpen] = useState(false);
    const [additionalTextFont, setAdditionalTextFont] = useState(ageVerificationTabData.additional_text_font);
    const [additionalTextFontDropdownOpen, setAdditionalTextFontDropdownOpen] = useState(false);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(ageVerificationTabData.custom_css);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(ageVerificationTabData.custom_js);
    
    // Handlers Overlay Background Color Change
    const handleOverlayBackgroundChange = (color) => {
        setOverlayBackgroundColor(color.hex);
        updateAgeVerificationTabData("overlay_background_color", color.hex);
    };

    //Handlers Popup Background Color Change
    const handlePopupBackgroundChange = (color) => {
        setPopupBackgroundColor(color.hex);
        updateAgeVerificationTabData("popup_background_color", color.hex);
    };

    //Handlers Text Color Change
    const handleTextColorChange = (color) => {
        setTextColor(color.hex);
        updateAgeVerificationTabData("text_color", color.hex);
    };

    //Handlers Submit Color Change
    const handleSubmitButtonColorChange = (color) => {
        setSubmitButtonColor(color.hex);
        updateAgeVerificationTabData("submit_button_color", color.hex);
    };

    //Handlers Yes Button Color Change
    const handleYesButtonColorChange = (color) => {
        setYesButtonColor(color.hex);
        updateAgeVerificationTabData("yes_button_color", color.hex);
    };

    //Handlers No Button Color Change
    const handleNoButtonColorChange = (color) => {
        setNoButtonColor(color.hex);
        updateAgeVerificationTabData("no_button_color", color.hex);
    };

    // Handlers Message Font Change
    const handleMessageFontChange = (font) => {
        setMessageFont(font);
        updateAgeVerificationTabData("message_font", font);
        setMessageFontDropdownOpen(false);
    };

    // Handlers Text Font Change 
    const handleTextFontChange = (font) => {
        setTextFont(font);
        updateAgeVerificationTabData("text_font", font);
        setTextFontDropdownOpen(false);
    };

    // Handlers Additional Text Font Change Additional
    const handleAdditionalTextFontChange = (font) => {
        setAdditionalTextFont(font);
        updateAgeVerificationTabData("additional_text_font", font);
        setAdditionalTextFontDropdownOpen(false);
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateAgeVerificationTabData("custom_css", code);
    };
    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateAgeVerificationTabData("custom_js", code);
    }; 

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => { 
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };
    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Appearance</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Overlay Background</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={overlayBackgroundColor} setColor={setOverlayBackgroundColor}  onChangeComplete={handleOverlayBackgroundChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Popup Background Color</span> 
                            <div className="color-pikr-box">
                                <ColorPicker color={popupBackgroundColor} setColor={setPopupBackgroundColor}  onChangeComplete={handlePopupBackgroundChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Text Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={textColor} setColor={setTextColor}  onChangeComplete={handleTextColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Submit Button Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={submitButtonColor} setColor={setSubmitButtonColor}  onChangeComplete={handleSubmitButtonColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Yes Button Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={yesButtonColor} setColor={setYesButtonColor}  onChangeComplete={handleYesButtonColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>No Button Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={noButtonColor} setColor={setNoButtonColor}  onChangeComplete={handleNoButtonColorChange}/>
                            </div>
                        </div>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Font</span>
                            <div className="color-pikr-box">
                                <em>{ageVerificationTabData.font_type}</em>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Message</span> 
                            <div className="color-pikr-box" onClick={() => setMessageFontDropdownOpen(!messageFontDropdownOpen)}>
                                <em>{messageFont}</em>
                                {messageFontDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["10px","11px","12px","13px","14px","15px","16px","17px","18px","19px","20px","22px","25px","27px","30px","32px","35px","37px","40px","42px"].map((font) => (
                                            <li key={font} onClick={() => handleMessageFontChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Text</span>
                            <div className="color-pikr-box" onClick={() => setTextFontDropdownOpen(!textFontDropdownOpen)}>
                                <em>{textFont}</em>
                                {textFontDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["10px","11px","12px","13px","14px","15px","16px","17px","18px","19px","20px","22px","25px","27px","30px","32px","35px","37px","40px","42px"].map((font) => (
                                            <li key={font} onClick={() => handleTextFontChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Additional Text</span>
                            <div className="color-pikr-box" onClick={() => setAdditionalTextFontDropdownOpen(!additionalTextFontDropdownOpen)}>
                                <em>{additionalTextFont}</em>
                                {additionalTextFontDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["10px","11px","12px","13px","14px","15px","16px","17px","18px","19px","20px","22px","25px","27px","30px","32px","35px","37px","40px","42px"].map((font) => (
                                            <li key={font} onClick={() => handleAdditionalTextFontChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Text Align</span>
                            <em>{ageVerificationTabData.text_align}</em>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default AppearanceTab;